import React, { useEffect, useState } from "react";
import { Button, Nav, Row, Col } from "reactstrap";
import { Modal } from "react-bootstrap";
import Loading from "../../../loader/loader";

const BankDetailsModal = (props) => {
  return (
    <>
      <Modal
        {...props}
        size="lg"
        className="rak-beneficiary-modal"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <h1 style={{ textAlign: "center" }}>Bank Details</h1>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="modal-body-content">
            <Col lg="5" className="label-bank-details">
              Bank Name
            </Col>
            <Col lg="1">:</Col>
            <Col lg="6" className="text-uppercase">
              {" "}
              {props.bankDetails && props.bankDetails.bankName}
            </Col>
          </Row>
          <Row className="modal-body-content">
            <Col lg="5" className="label-bank-details">
              Country
            </Col>
            <Col lg="1">:</Col>
            <Col lg="6" className="text-uppercase">
              {" "}
              {props.bankDetails && props.bankDetails.country}
            </Col>
          </Row>
          <Row className="modal-body-content">
            <Col lg="5" className="label-bank-details">
              Type
            </Col>
            <Col lg="1">:</Col>
            <Col lg="6" className="text-uppercase">
              {" "}
              {props.bankDetails && props.bankDetails.transferType}
            </Col>
          </Row>
          <Row className="modal-body-content">
            <Col lg="5" className="label-bank-details">
              Branch Name
            </Col>
            <Col lg="1">:</Col>
            <Col lg="6" className="text-uppercase">
              {" "}
              {props.bankDetails && props.bankDetails.bankBranchName}
            </Col>
          </Row>
          <Row className="modal-body-content">
            {props.bankDetails && props.bankDetails.country === "PK" ? (
              <Col lg="5" className="label-bank-details">
                IBAN
              </Col>
            ) : (
              <Col lg="5" className="label-bank-details">
                IFSC Code
              </Col>
            )}
            <Col lg="1">:</Col>
            <Col lg="6" className="text-uppercase">
              {" "}
              {props.bankDetails && props.bankDetails.ifscCode}
            </Col>
          </Row>
          <Row className="modal-body-content">
            <Col lg="5" className="label-bank-details">
              Account Number
            </Col>
            <Col lg="1">:</Col>
            <Col lg="6" className="text-uppercase">
              {" "}
              {props.bankDetails && props.bankDetails.accountNumber}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          {props.bankrecordStatus && props.bankrecordStatus === "PENDING" ? (
            <Button
              variant="secondary"
              color="success"
              disabled={props.bankApproveLoading}
              onClick={(e) =>
                props.approveClicked(props.bankDetails && props.bankDetails.id)
              }
            >
              {props.bankApproveLoading ? <div style={{ display: "flex", justifyContent: "center" }}>
                <Loading color="white" width="20px" height="20px" />
              </div> :
                'Approve'}
            </Button>
          ) : null}
          <Button
            variant="primary"
            color="danger"
            disabled={props.deleteBeneficiaryLoader}
            onClick={() =>
              props.deleteClicked(props.bankDetails && props.bankDetails.id)
            }
          >
            {props.deleteBeneficiaryLoader ? <div style={{ display: "flex", justifyContent: "center" }}>
              <Loading color="white" width="20px" height="20px" />
            </div> :
              'Delete'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default BankDetailsModal;
